"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var app_1 = require("firebase/app");
var functions_1 = require("firebase/functions");
var firestore_1 = require("firebase/firestore");
var types_1 = require("@swyft/types");
var errorHandler_1 = __importDefault(require("../errorHandler"));
var merchants_1 = require("../../models/merchants");
var merchant_zones_1 = require("../../models/merchant-zones");
var MerchantController = /** @class */ (function () {
    /**
     * Creates MerchantController instance with provided config to setup Firebase app.
     * @param {FirebaseOptions} config Firebase configuration to initialize app.
     */
    function MerchantController(config) {
        var _this = this;
        /**
         * Create a merchant
         * @param params.data data needed to create a new merchant
         * @returns the id of the newly created merchant
         */
        this.create = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.createMerchant(params.data)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Update a merchant
         * @param params merchant fields to update
         * @returns the updated merchant object
         */
        this.update = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var id, data, updatedMerchant, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = params.id, data = params.data;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, merchants_1.update)(this.db, {
                                id: id,
                                data: data
                            })];
                    case 2:
                        updatedMerchant = _a.sent();
                        return [2 /*return*/, { data: updatedMerchant }];
                    case 3:
                        err_2 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_2)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get a single merchant
         * @param params.id the id of the merchant
         * @returns the merchant object
         */
        this.getOne = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var merchant;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, merchants_1.get)(this.db, {
                            id: params.id
                        })];
                    case 1:
                        merchant = _a.sent();
                        return [2 /*return*/, { data: merchant }];
                }
            });
        }); };
        /**
         * Deactivate a particular merchant-zone
         * @param params.merchantId the merchant making the deactivation request
         * @param params.zoneId the zone id to deactivate
         * @returns void if successful
         */
        this.deactivateZone = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.deactivateZone(params)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_3)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Request activation for a particular zone, for a merchant.
         * Data comes from the request quote flow.
         * @param params data needed to request zone activation for a merchant
         * @returns the merchant object zone activation was requested for
         */
        this.requestZoneActivation = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.activateZone(params)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_4)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get a list of zones for a merchant (merchant-zone)
         * @param params.id the merchant id
         * @returns a list of merchant-zone objects
         */
        this.getZones = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var zones;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, merchant_zones_1.list)(this.db, {
                            id: params.id
                        })];
                    case 1:
                        zones = _a.sent();
                        return [2 /*return*/, { data: zones }];
                }
            });
        }); };
        /**
         * Get rates from a merchant-zone or from merchant document depending on params
         * @param params the merchant, zone, and country details. The merchant id must be provided.
         * @returns the rate card for the specified merchant
         */
        this.getRates = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var rates;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, merchants_1.getRates)(this.db, { id: params.merchantId })];
                    case 1:
                        rates = _a.sent();
                        return [2 /*return*/, { data: rates }];
                }
            });
        }); };
        /**
         * Send an email to the sales team
         * @param params.merchantId the merchant this message is from
         * @param params.message the plain-text message to send
         * @returns void if successful
         */
        this.contactSales = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.contactSales(params)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_5)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Send an email to zendesk support to create a support/claim ticket for a particular label/invoice
         */
        this.contactMerchantSupport = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.contactMerchantSupport(params)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_6 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_6)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var firebaseApp = (0, app_1.initializeApp)(config);
        var firebaseFunctions = (0, functions_1.getFunctions)(firebaseApp);
        this.db = (0, firestore_1.getFirestore)(firebaseApp);
        this.functions = {
            createMerchant: (0, functions_1.httpsCallable)(firebaseFunctions, "merchants-createMerchant"),
            deactivateZone: (0, functions_1.httpsCallable)(firebaseFunctions, "merchants-deactivateZone"),
            activateZone: (0, functions_1.httpsCallable)(firebaseFunctions, "merchants-activateZone"),
            contactSales: (0, functions_1.httpsCallable)(firebaseFunctions, "merchants-contactSales"),
            contactMerchantSupport: (0, functions_1.httpsCallable)(firebaseFunctions, "merchants-contactMerchantSupport")
        };
    }
    /**
     *
     * @param merchant
     * @returns the active rate card type or the default {@link RateCardType.rateCard}
     */
    MerchantController.getMerchantRateCardType = function (merchant) {
        return merchant.activeRateCard || types_1.RateCardType.rateCard;
    };
    /**
     *
     * @param merchant
     * @returns the active rate card or the default {@link RateCardType.rateCard}
     */
    MerchantController.getMerchantRateCard = function (merchant) {
        var rateCardType = MerchantController.getMerchantRateCardType(merchant);
        return {
            rateCardType: rateCardType,
            rateCard: merchant[rateCardType]
        };
    };
    MerchantController.isRateCardAddOnAvailable = function (merchant, addOn) {
        var _a, _b;
        return !!((_b = (_a = MerchantController.getMerchantRateCard(merchant).rateCard) === null || _a === void 0 ? void 0 : _a.addOns) === null || _b === void 0 ? void 0 : _b[addOn]);
    };
    /**
     *
     * @param rateCard
     * @param serviceType
     * @param weight
     * @returns all rate card entries that satisfies the service type and weight range condition
     */
    MerchantController.getRatesByService = function (rateCard, serviceType, weight) {
        return (rateCard.entries || []).filter(function (item) {
            return item.serviceType === serviceType &&
                weight >= item.minWeight &&
                weight <= item.maxWeight;
        });
    };
    /**
     *
     * @param rateCard
     * @param serviceType
     * @param weight
     * @returns the lowest rate that can fulfill the service type and weight
     */
    MerchantController.getMinRateEntryByService = function (rateCard, serviceType, dims) {
        if (!dims) {
            return null;
        }
        var rates = MerchantController.getRatesByService(rateCard, serviceType, dims.weight).sort(function (a, b) { return a.rate - b.rate; });
        return rates.length === 0 ? null : rates[0];
    };
    /**
     *
     * @param rateCard
     * @param serviceType
     * @param weight
     * @returns the lowest rate that can fulfill the service type and weight
     */
    MerchantController.getMinRateByService = function (rateCard, serviceType, dims) {
        var _a;
        if (!dims) {
            return null;
        }
        var rateEntry = MerchantController.getMinRateEntryByService(rateCard, serviceType, dims);
        return (_a = rateEntry === null || rateEntry === void 0 ? void 0 : rateEntry.rate) !== null && _a !== void 0 ? _a : null;
    };
    return MerchantController;
}());
exports["default"] = MerchantController;
